import { Effect } from '@babylonjs/core/Materials/effect';

import fragment from './TourDanjiSkyLightShader.fragment.fx';
import vertex from './TourDanjiSkyLightShader.vertex.fx';

Effect.ShadersStore['tourdanjiSkyLightVertexShader'] = vertex;
Effect.ShadersStore['tourdanjiSkyLightFragmentShader'] = fragment;
